import * as React from 'react';
import format from 'date-fns/format'
import 'chartjs-adapter-date-fns';
import { Bar} from 'react-chartjs-2';
import {
    Chart as ChartJS,
    TimeScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    CategoryScale,
    BarElement
} from 'chart.js';
import _ from 'lodash'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { render } from '@testing-library/react';

ChartJS.register( Title, Legend,CategoryScale,BarElement);


const TmcChart = (props) => {
    const totalYes = props.totalCount;
    const northCount = props.northCount;
    const eastCount= props.eastCount;
    const westCount = props.westCount;
    const southCount = props.southCount;
    const northEastCount = props.northEastCount;
    const northWestCount = props.northWestCount;
    const southEastCount = props.southEastCount;
    const southWestCount = props.southWestCount;

    if(totalYes > 1){
        // Build arrays of directions and counts, filtering out directions with count <= 0
        const directions = [];
        const counts = [];
        
        const directionData = [
            { label: 'North', count: northCount },
            { label: 'Northeast', count: northEastCount },
            { label: 'East', count: eastCount },
            { label: 'Southeast', count: southEastCount },
            { label: 'South', count: southCount },
            { label: 'Southwest', count: southWestCount },
            { label: 'West', count: westCount },
            { label: 'Northwest', count: northWestCount }
        ];
        
        directionData.forEach(item => {
            if (item.count > 0) {
                directions.push(item.label);
                counts.push(item.count);
            }
        });
      
        return (
          <div style={{height:"150px", width:"300px"}}>
            <Bar 
                data= {{labels: directions,
                datasets: [
                {
                  label: 'Vehicles Heading This Direction',
                  backgroundColor: 'rgba(75,192,192,1)',
                  borderColor: 'rgba(0,0,0,1)',
                  borderWidth: 2,
                  data: counts
                }
                ]}}
                options = {{
                 plugins:{
                  title:{
                       display:true,
                      text:'Outbound Turning Movement Counts',
                     fontSize:20
                    },
                    legend:{
                      display:false,
                        position:'right'
                    },
                    maintainAspectRatio:true
                 },
                 scales:{
                    x:{
                      ticks:{
                        color:'#000000'
                      }
                    },
                    y:{
                      ticks:{
                        color:'#000000'
                      }
                    }
                 }}}
                 
            />
            </div>
        )
    }else {
        return (
            <Box sx={{ height: 100, mt: 5, textAlign: "center" }}><Typography variant="h5">Loading Data</Typography></Box>
        )
    }
};

export default TmcChart
